import {styled} from "@mui/material";

export const OrderCardsContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',

    '& .MuiGrid-item': {
        // flexGrow: 0,
    }
}));